import { Box } from '@dtx-company/design-system/src'
import Image from 'next/image'
import { FC } from 'react'
import { SOCIAL_MEDIA_LINKS } from '../socialMediaLinks'

const ICON_PX = 24

export const FooterLoggedOutSocialLinks: FC = () => {
  return (
    <Box
      role="list"
      aria-label="Social media"
      sx={{
        color: 'inherit',
        display: 'grid',
        gridTemplateColumns: `repeat(${SOCIAL_MEDIA_LINKS.length}, max-content)`,
        gap: { xs: 4.5, xl: 6 },
        alignItems: 'center'
      }}
    >
      {SOCIAL_MEDIA_LINKS.map(({ url, iconUrl, alt }, index) => (
        <Box key={`social-${index}-${alt}`} component="span" role="listitem" sx={{ lineHeight: 0 }}>
          <a href={url} target="_blank" rel="noopener noreferrer" aria-label={alt}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: ICON_PX,
                height: ICON_PX,
                color: 'inherit'
              }}
            >
              <Image
                src={iconUrl}
                alt=""
                width={ICON_PX}
                height={ICON_PX}
                style={{ objectFit: 'contain' }}
              />
            </Box>
          </a>
        </Box>
      ))}
    </Box>
  )
}
